"use client";
export default function Pagination({
    page = 1,
    totalPages = 1,
    total = 0,
    className = "",
    onPageChange,
}) {
    const currentPage = Math.max(1, page);
    const lastPage = Math.max(1, totalPages);

    // Only show window of pages
    const getPages = () => {
        const delta = 2;
        let start = Math.max(1, currentPage - delta);
        let end = Math.min(lastPage, currentPage + delta);
        if (currentPage <= delta) end = Math.min(lastPage, 1 + delta * 2);
        if (currentPage + delta >= lastPage)
            start = Math.max(1, lastPage - delta * 2);
        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    };

    return (
        <nav
            className={`mt-8 flex justify-center gap-1 items-center text-xs ${className}`}
            aria-label="Pagination"
        >
            <button
                className="px-3 py-1 rounded border disabled:opacity-40"
                disabled={currentPage <= 1}
                onClick={() => onPageChange(currentPage - 1)}
            >
                Prev
            </button>
            {getPages().map((p) => (
                <button
                    key={p}
                    className={`px-3 py-1 rounded border transition ${
                        p === currentPage
                            ? "bg-primary text-white border-primary"
                            : "border-gray-200 hover:bg-gray-50"
                    }`}
                    disabled={p === currentPage}
                    onClick={() => onPageChange(p)}
                >
                    {p}
                </button>
            ))}
            <button
                className="px-3 py-1 rounded border disabled:opacity-40"
                disabled={currentPage >= lastPage}
                onClick={() => onPageChange(currentPage + 1)}
            >
                Next
            </button>
            <span className="ml-4 text-gray-400">
                Page {currentPage} of {lastPage} — {total} results
            </span>
        </nav>
    );
}
